import styled from 'styled-components';

const LogoStyle = styled.div`
	.image-cont {
		background-color: transparent !important;
	}
`;

export default LogoStyle;
